import RouteIndex from './Routes/Index';

import './assets/scss/themes.scss';

function App() {
    return <RouteIndex />;
}

export default App;
